<h2 class="step-label">{{ label }}</h2>
<mat-chip-list
  selectable
  class="mat-chip-list-stacked"
>
  <mat-chip
    class="chip"
    *ngFor="let option of options$ | async"
    (click)="handleSingleOptionClick(option)"
    (keydown)="handleChipKeydown($event, option)"
    [selected]="selectedOption === option"
    [attr.data-test]="'chip-option-' + (formItem.type === 'refdata-chipgroup' ? option.label : option.value)"
  >
    <span class="chip-text">{{ option.label }}</span>
  </mat-chip>
</mat-chip-list>
